export function profile_menu_info()
{
    if( document.querySelector(".majixel_profile .profile_info")!==null && document.querySelector(".majixel_profile .profile_info")!==undefined ){
        let $profile_info_button = document.querySelector(".majixel_profile .profile_info");
        $profile_info_button.addEventListener( 'click', event => {
            if( ! $profile_info_button.classList.contains( 'active' ) )
            {
                event.preventDefault();
            }
            let $menu_info = document.querySelector( ".profile_info_menu" );
            if( $menu_info.classList.contains("show") )
            {
                $profile_info_button.classList.remove("active");
                $profile_info_button.childNodes[2].classList.remove("fa-angle-up");
                $profile_info_button.childNodes[2].classList.add("fa-angle-down");
                $menu_info.classList.remove("show");
            }else{
                $profile_info_button.classList.add("active");
                $profile_info_button.childNodes[2].classList.remove("fa-angle-down");
                $profile_info_button.childNodes[2].classList.add("fa-angle-up");
                $menu_info.classList.add("show");
            }
        } );
    }
}